<div class="flex">
  <app-graphic-side-panel
    class="hidden h-screen w-[50vw] md:flex"
    [subtext]="'Sign up to go to your portal'"
  ></app-graphic-side-panel>
  <div class="flex h-screen w-screen items-center justify-center md:w-[50vw]">
    @if (signedIn) {
      <div class="mx-6 w-full max-w-lg">
        <div class="flex justify-center">
          <div class="loading loading-spinner h-8 w-8"></div>
        </div>
      </div>
    } @else {
      <div class="mx-6 mt-12 w-full max-w-lg">
        <img
          class="mx-auto my-4 w-36 md:hidden"
          src="../../../assets/accuzip-logo-white.png"
          alt="AccuZIP Logo"
        />
        <h1
          class="z-10 m-auto hidden max-w-lg select-none text-5xl font-semibold leading-normal md:block"
        >
          Sign Up
        </h1>
        <h1
          class="z-10 m-auto max-w-lg select-none text-center text-3xl font-semibold leading-normal md:hidden"
        >
          Sign up to the Customer Portal
        </h1>
        @if (!infoVerified) {
          <div class="mt-8">
            <p>Enter your account details below to get started</p>
          </div>
          <div class="my-8">
            <input
              type="text"
              class="input input-bordered w-full"
              placeholder="Account Number"
              [(ngModel)]="accountNumber"
            />
          </div>

          <div class="my-8">
            <input
              type="text"
              class="input input-bordered w-full"
              placeholder="Email"
              [(ngModel)]="email"
            />
          </div>

          <div class="my-8">
            <input
              type="text"
              class="input input-bordered w-full"
              placeholder="Account Zip Code"
              [(ngModel)]="zipcode"
            />
          </div>

          <div>
            <button
              class="btn btn-primary w-full"
              (click)="verifyAndInviteUser()"
              [disabled]="verifyingInfo || infoVerified"
            >
              Submit
            </button>
          </div>

          <div class="my-6">
            <p class="text-center text-sm">
              Already have an account?
              <a class="link" [routerLink]="'/login'">Sign in here</a>
            </p>
          </div>
        } @else if (infoVerified) {
          <div class="my-8">
            <p class="text-3xl font-semibold text-success">Success!</p>
            <p class="mt-4">
              An invitation has been sent to your email address. Please check
              your inbox for the invitation and follow the instructions to
              register your account.
            </p>
          </div>
        }

        @if (errorType) {
          @if (errorType === 'invalidAccountNumber') {
            <p class="mt-4 text-red-500">
              Please enter a valid account number. Account numbers should be 10
              digits long, starting with 77 and ending with 01.
            </p>
          } @else if (errorType === 'invalidZipCode') {
            <p class="mt-4 text-red-500">Please enter a valid zip code.</p>
          } @else if (errorType === 'invalidInfo') {
            <p class="mt-4 text-red-500">
              The details provided cannot be verified. Please check your
              information and try again. If you need further assistance, visit
              <a
                class="underline"
                href="https://accuzip.com/contact"
                target="_blank"
                >accuzip.com/contact</a
              >
              to contact AccuZIP support.
            </p>
          } @else if (errorType === 'userExists') {
            <p class="mt-4 text-red-500">
              A user already exists for the provided details. Please sign in to
              your account using the link above.
            </p>
          } @else if (errorType === 'unexpectedError') {
            <p class="mt-4 text-red-500">
              An unexpected error occurred while verifying your information,
              please try again. If you need further assistance, visit
              <a
                class="underline"
                href="https://accuzip.com/contact"
                target="_blank"
                >accuzip.com/contact</a
              >
              to contact AccuZIP support.
            </p>
          }
        }
      </div>
    }
  </div>
</div>
